import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { PackageUser } from 'src/app/features/package-users/models/PackageUser.model';
import { PackageUserRole } from 'src/app/features/package-users/models/package-user-role.enum';
import { FaqPayoff } from '../../models/faq-data.model';
import { HelpFaqSelectors } from '../../store/selectors';
import { ChatBubble, ChatChip, ChatItem, ChatTyping } from '../chat-widget/chat-conversation.logic';

export type ChipsDirection = 'row' | 'column';

export { ChatBubble, ChatChip, ChatItem, ChatTyping };

@Component({
  selector: 'app-chat-window',
  templateUrl: './chat-window.component.html',
  styleUrls: ['./chat-window.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChatWindowComponent {
  @Input() items: ChatItem[] = [];
  @Input() chips: ChatChip[] = [];
  @Input() rootChips: ChatChip[] = [];
  @Input() selectedRootChipId = '';
  @Input() chipsDisabled = false;
  @Input() chipsDirection: ChipsDirection = 'column';

  @Output() chipClick = new EventEmitter<ChatChip>();
  @Output() minimize = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  protected readonly disbursementDate$: Observable<string | null> =
    this.store.select(HelpFaqSelectors.getDisbursementDate);
  protected readonly firstPaymentDate$: Observable<string | null> =
    this.store.select(HelpFaqSelectors.getFirstPaymentDate);
  protected readonly interestRate$: Observable<number | null> =
    this.store.select(HelpFaqSelectors.getInterestRate);
  protected readonly monthlyPayment$: Observable<number | null> =
    this.store.select(HelpFaqSelectors.getMonthlyPayment);
  protected readonly prepaymentPenalty$: Observable<string | null> =
    this.store.select(HelpFaqSelectors.getPrepaymentPenalty);
  protected readonly payoffs$: Observable<FaqPayoff[]> =
    this.store.select(HelpFaqSelectors.getPayoffs);
  protected readonly borrowers$: Observable<PackageUser[]> =
    this.store.select(HelpFaqSelectors.getSigners);

  constructor(private readonly store: Store) {}

  protected onChipClick(chip: ChatChip): void {
    this.chipClick.emit(chip);
  }

  protected isBubble(item: ChatItem): item is ChatBubble {
    return item.kind === 'bot' || item.kind === 'user';
  }

  protected isTyping(item: ChatItem): item is ChatTyping {
    return item.kind === 'typing';
  }

  protected roleLabel(role: PackageUserRole): string {
    switch (role) {
      case PackageUserRole.BORROWER: return 'Borrower';
      case PackageUserRole.SELLER: return 'Seller';
      case PackageUserRole.SIGNER: return 'Signer';
      case PackageUserRole.NBTH: return 'NBTH';
      case PackageUserRole.WITNESS: return 'Witness';
      case PackageUserRole.SIGNINGAGENT: return 'Signing Agent';
      default: return '';
    }
  }
}
